import { Input } from "antd";
import React from "react";
import styled from "styled-components";
import { OpenEyeIcon, CloseEyeIcon } from "@assets";

const PasswordInput = styled(Input.Password)`
  background-color: #F2F1F0;

  height: 56px;
  &::placeholder {
    text-align: left;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    color: #7E8485;
  }

   input {
    text-align: left !important;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    background-color: #F2F1F0;

  }
  
  &&& {
    border-radius: 12px;
    text-align: left !important;
    padding-left: 17px;
    color: #101415;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`

const InputPassword = ({ placeholder, ...props }) => {
  
  const handleKeyDown = (event) => {
    const key = event.key;
    const isAllowedKey = /^[0-9\b]+$/.test(key);
    if (!isAllowedKey && key !== "Backspace") {
      event.preventDefault();
    }
  };

  return (

    <PasswordInput 
      size="large"
      placeholder={placeholder}
      onKeyDown={handleKeyDown}
      iconRender={(visible) => (visible ? <OpenEyeIcon /> : <CloseEyeIcon />)}
      {...props}
    />
  );
};

export default InputPassword;
